import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/auth/apple/callback": [4],
		"/auth/kakao/callback": [5],
		"/auth/login": [6],
		"/auth/naver/callback": [7],
		"/consent/[token]": [8],
		"/dashboard": [9,[2]],
		"/dashboard/academy": [10,[2]],
		"/dashboard/academy/create": [11,[2]],
		"/dashboard/announcements": [12,[2]],
		"/dashboard/announcements/[id]": [13,[2]],
		"/dashboard/attendance": [14,[2]],
		"/dashboard/attendance/check": [15,[2]],
		"/dashboard/courses": [16,[2]],
		"/dashboard/courses/create": [18,[2]],
		"/dashboard/courses/[id]": [17,[2]],
		"/dashboard/forms": [19,[2]],
		"/dashboard/forms/create": [21,[2]],
		"/dashboard/forms/[id]": [20,[2]],
		"/dashboard/inquiries": [22,[2]],
		"/dashboard/inquiries/create": [25,[2]],
		"/dashboard/inquiries/[id]": [23,[2]],
		"/dashboard/inquiries/[id]/edit": [24,[2]],
		"/dashboard/makeups": [26,[2]],
		"/dashboard/makeups/create": [28,[2]],
		"/dashboard/makeups/[id]": [27,[2]],
		"/dashboard/materials": [29,[2]],
		"/dashboard/placements": [30,[2]],
		"/dashboard/placements/create": [32,[2]],
		"/dashboard/placements/[id]": [31,[2]],
		"/dashboard/points": [33,[2]],
		"/dashboard/schedule": [34,[2]],
		"/dashboard/schedule/holidays": [35,[2]],
		"/dashboard/schedule/monthly": [36,[2]],
		"/dashboard/schedule/monthly/[yearMonth]": [37,[2]],
		"/dashboard/schedule/yearly": [38,[2]],
		"/dashboard/settings": [39,[2]],
		"/dashboard/settings/calendar": [40,[2]],
		"/dashboard/settings/delete-account": [41,[2]],
		"/dashboard/settings/profile": [42,[2]],
		"/dashboard/students": [43,[2]],
		"/dashboard/students/create": [46,[2]],
		"/dashboard/students/[id]": [44,[2]],
		"/dashboard/students/[id]/attendance": [45,[2]],
		"/faq": [47],
		"/policy/privacy": [48],
		"/policy/terms": [49]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';